
 /**
 * @desc 富文本编辑器
 * @props ossType 上传文件属于哪个模块 {course 课程 , activity 活动 , avatar 头像}
 * @props editorContent.sync 双向绑定的富文本内容
 */
import CRichtext from './CRichtext'

export default CRichtext;